import type { FeedbackEvent } from "./types";

export const FEEDBACK_LIFETIME_SECONDS = 1.35;

export type FeedbackDraft = Omit<FeedbackEvent, "id" | "createdAtSeconds">;

export function createFeedbackEvent(event: FeedbackDraft, id: number, createdAtSeconds: number): FeedbackEvent {
  return {
    ...event,
    id,
    createdAtSeconds
  };
}

export function pruneExpiredFeedback(feedback: readonly FeedbackEvent[], elapsedSeconds: number): FeedbackEvent[] {
  return feedback.filter((event) => elapsedSeconds - event.createdAtSeconds <= FEEDBACK_LIFETIME_SECONDS);
}
